import * as React from 'react';

import { useDispatch } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { push } from 'connected-react-router';

import styled from 'styled-components';
import { rgba } from 'polished';

import Typography from '@components/basics/typography';
import RightArrowIcon from '@components/basics/icons/right-arrow';

interface ArtistDeleteCtrlProps {
  className?: string;
}

export const ArtistDeleteCtrl: React.FC<ArtistDeleteCtrlProps> = ({
  className,
}) => {
  const dispatch = useDispatch();

  return (
    <StyledDeleteButton
      className={className}
      onClick={() => dispatch(push('/artist/deactivate'))}
    >
      <Label weight="700">
        <Translate id="ARTIST.DEACTIVATE.TITLE" />
      </Label>
      <ArrowWrapper>
        <RightArrowIcon className="icon" />
      </ArrowWrapper>
    </StyledDeleteButton>
  );
};

export default ArtistDeleteCtrl;

const StyledDeleteButton = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.box};
  padding: 20px;
  width: 100%;
  cursor: pointer;
`;

const ArrowWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  background-color: ${({ theme }) => rgba(theme.colors.accent, 0.1)};
  cursor: pointer;

  .icon {
    width: 9px;

    path {
      fill: ${({ theme }) => theme.colors.accent};
    }
  }
`;

const Label = styled(Typography)`
  color: ${({ theme }) => theme.colors.accent};
`;
